<template>
    <div>
        <router-link class="btn btn-success mr-2" :to="{name: 'admin.wallet.client.createTransfer'}">
            Create Transfer Manually
        </router-link>
        <router-link v-if="client.wallet.amount > 0" class="btn btn-success" :to="{name: 'admin.wallet.client.createWithdraw'}">
            Create Withdraw
        </router-link>
        <table class="table table-bordered table-striped mt-4">
            <thead>
            <tr>
                <th>ID</th>
                <th>Created At</th>
                <th>Updated At</th>
                <th>Amount</th>
                <th>Payment system ID</th>
                <th>Status</th>
                <th>Expedited</th>
                <th>Commission</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="transfer in transfers" :key="transfer.id">
                <td>{{ transfer.id }}</td>
                <td>{{ formatedDate(transfer.created_at) }}</td>
                <td>{{ formatedDate(transfer.updated_at) }}</td>
                <td>{{ transfer.amount + ' ' + transfer.currency }}</td>
                <td>{{ '(' + transfer.payment_system + ') ' + transfer.payment_system_id }}</td>
                <td>{{ transfer.status }}</td>
                <td>{{ transfer.is_expedited ? 'Yes' : 'No' }}</td>
                <td>{{ transfer.commission ? (transfer.currency + transfer.commission)  : '--' }}</td>
            </tr>
            </tbody>
        </table>
        <b-pagination
            v-if="paginator.total / paginator.perPage > 1"
            :value="page"
            :total-rows="paginator.total"
            :per-page="paginator.perPage"
            @change="change($event)"
        ></b-pagination>
    </div>
</template>

<script>
export default {
    name: "Transfers",
    props: {
        'page': {
            'default': 1
        },
        'client': {}
    },
    data() {
        return {
            transfers: [],
            paginator: []
        }
    },
    methods: {
        formatedDate(date) {
            return window.moment(date).tz('America/New_York').format('hh:mm A DD MMM YYYY');
        },
        change(event) {
            this.getPayments(event);
        },
        getPayments(page) {
            window.axios.get('/admin/wallet/client/' + this.client.id + '/transfers', {params: {page: page}})
                .then(response => {
                        this.transfers = response.data.transfers;
                        this.paginator.perPage = response.data.per_page;
                        this.paginator.total = response.data.count;
                    }
                );
        },
    },
    mounted() {
        this.getPayments(this.page);
    }
}
</script>